<div *transloco="let t;" class="wizard-container search-results" infiniteScroll [infiniteScrollDistance]="0" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
  <div class="list-container">
    <div class="kryptomons-cards">
      <div class="header-sorting">
        <div class="search-input">
          <fa-icon [icon]="['fas', 'search']" *ngIf="showSearchIcon"></fa-icon>
          <tag-input class="chips-tag" type="number" [(ngModel)]="searchId" placeholder="Search Kryptomon by ID" (onAdd)="searchById($event)" (onRemove)="cleanSearchId($event)" secondaryPlaceholder="Search Kryptomon by ID" [separatorKeys]="[',']" [addOnPaste]="true" [disable]="!parsedSuccess"></tag-input>
        </div>
        <div class="sorting-item-container">
          <div class="sorting-item">
            <div class="sorting-item-visible" (click)="toggleSortingBox(0)">
              {{selectedPriceSorting}}
              <fa-icon [icon]="['fas', 'caret-down']" *ngIf="!sortingArray[0]"></fa-icon>
              <fa-icon [icon]="['fas', 'caret-up']" *ngIf="sortingArray[0]"></fa-icon>
            </div>
            <div class="sorting-box" *ngIf="sortingArray[0]">
              <div class="sorting-box-item" (click)="sortByPrice('cheapest')">
                {{t('shared.cheapest')}}
              </div>
              <div class="sorting-box-item" (click)="sortByPrice('most expensive')">
                {{t('shared.mostExpensive')}}
              </div>
            </div>
          </div>
          <div class="sorting-item">
            <div class="sorting-item-visible" (click)="toggleSortingBox(1)">
              {{selectedTimeSorting}}
              <fa-icon [icon]="['fas', 'caret-down']" *ngIf="!sortingArray[1]"></fa-icon>
              <fa-icon [icon]="['fas', 'caret-up']" *ngIf="sortingArray[1]"></fa-icon>
            </div>
            <div class="sorting-box" *ngIf="sortingArray[1]">
              <div class="sorting-box-item" (click)="sortByTime('newest')">
                {{t('shared.newest')}}
              </div>
              <div class="sorting-box-item" (click)="sortByTime('recently listed')">
                {{t('shared.recentlyListed')}}
              </div>
            </div>
          </div>
        </div>
        <div class="toggle-item-container">
          <div class="toggle-item">
            <input type="checkbox" id="switch_sale" [checked]="isOnSaleFilter" /><label for="switch_sale" (click)="toggleSale()">sale_toggle</label>{{t('shared.onSale')}}
          </div>
          <div class="toggle-item">
            <input type="checkbox" id="switch_breed" [checked]="isOnBreedFilter" /><label for="switch_breed" (click)="toggleBreed()">breed_toggle</label>{{t('shared.breedable')}}
          </div>
        </div>
      </div>
      <!-- <div class="loading-container" *ngIf="!parsedSuccess">
        <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
      </div> -->
      <div class="kryptomons-container" *ngIf="parsedSuccess">
        <div *ngIf="(parsedKryptomon | kryptomonMarketRanking:tierFilter | kryptomonMainPower:mainPowerFilter | kryptomonSecondPower: secondPowerFilter).length === 0" class="empty-set">
          <fa-icon [icon]="['fas', 'search']"></fa-icon>
          <span>{{t('shared.noMatches')}}</span>
        </div>
        <div class="other-card" *ngFor="let kr of parsedKryptomon | kryptomonMarketRanking:tierFilter | kryptomonMainPower:mainPowerFilter | kryptomonSecondPower: secondPowerFilter" id="otherKryptomon">
          <a routerLink="/kryptomons/{{kr.data.tokenId}}" href="/kryptomons/{{kr.data.tokenId}}">
            <div class="other-card-img" [ngClass]="{'full-width': kr.data.status==0}">
              <img src="{{kr.data.image}}" />
            </div>
            <div class="other-card-content">
              <div class="name-row">
                <span>{{kr.data.name}}</span>
                <div class="price-div" *ngIf="kr.data.order">
                  <span class="price-span">${{kr.data.order.priceUSD.toLocaleString()}}</span>
                  <img src="./assets/img/Icon/Cur-BNB.png" *ngIf="kr.data.order.paymentToken=='0x0000000000000000000000000000000000000000'">
                  <img src="./assets/img/Icon/Cur-Kmon.png" *ngIf="kr.data.order.paymentToken!=='0x0000000000000000000000000000000000000000'">
                </div>
              </div>
              <div class="other-card-rating">
                <div class="Stars" style="--rating: {{kr.data.starValue}}"></div>
                {{kr.data.tierName}}
              </div>
              <span>{{t('shared.speciality')}}: {{kr.data.data.kryptomon.speciality}}</span>
              <div class="other-card-icons">
                <div class="other-card-starter" *ngIf="kr.data.isStarter">
                  <img src="./assets/img/Icon/Starter.png" />
                </div>
                <div class="other-card-element">
                  <img src="{{kr.data.mainFamilyImage}}" />
                </div>
                <div class="other-card-element">
                  <img src="{{kr.data.secondaryFamilyImage}}" />
                </div>
                <div class="other-card-breed" *ngIf="kr.data.breedingTotal">
                  <img src="./assets/img/Icon/Heart.png" />
                  {{kr.data.breedingDone}}/{{kr.data.breedingTotal}}
                </div>
                <div class="other-card-sex">
                  <img src="{{kr.data.genderIcon}}" />
                </div>
                <div class="other-card-gen">
                  GEN: {{kr.data.data.kryptomon.genes.generation}}
                </div>
              </div>
            </div>
          </a>
        </div>
        <!-- <div class="loading-container" *ngIf="loadInfinite">
          <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
        </div> -->
      </div>
      <div *ngIf="!loadInfinite" class="flex w-full justify-center p-5">
        <!-- <k-button check-cookies-expired (click)="onScroll()">{{t('shared.showMore')}}</k-button> -->
        <k-button check-cookies-expired (click)="onScroll()" [label]="t('shared.showMore')"></k-button>
      </div>
    </div>
    <div class="items-filter">
      <div class="filter-card" [ngClass]="{'open':openFilter}">
        <div class="filter-card-title">
          <h3>{{t('shared.filterCategories')}}</h3>
          <div class="filter-icon" (click)="openFilter=!openFilter">
            <img src="./assets/img/Icon/filter.png" *ngIf="!openFilter" />
            <img src="./assets/img/Icon/Close.png" *ngIf="openFilter" />
          </div>
        </div>
        <div class="remove-filters" (click)="clearFilters()">
          <div class="remove-icon">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
          </div>{{t('shared.showAll')}}
        </div>
        <div class="filter-section">
          <span class="filter-title">{{t('shared.powerState')}}</span>
          <div class="filter-item-container">
            <div class="filter-item">
              <!--<div class="img-background">
              <img src="{{filterItem.img}}" *ngIf="filterItem.img" />
            </div>-->
              <div class="tier-item" *ngFor="let ti of tierArray, let i = index" (click)="selectTier(i)" [ngClass]="{'selected': ti.selected}">
                <div class="Stars_3" style="--rating: {{ti.value}}">
                </div><span>{{ti.type}}</span>
              </div>
              <!--<div class="tier-item" (click)="selectTier('Veteran')">
                <div class="Stars_3" style="--rating: 2">
                </div><span>Veteran</span>
              </div>
              <div class="tier-item" (click)="selectTier('Elite')">
                <div class="Stars_3" style="--rating: 3">
                </div><span>Elite</span>
              </div>-->
            </div>
          </div>
        </div>
        <div class="filter-section">
          <!--<span class="filter-title">Aura</span>-->
          <div class="filter-item-container">
            <div class="filter-item">
              <div class="toggle-item">
                <img src="./assets/img/Icon/aura.svg"/>Aura<input type="checkbox" id="switch_aura" [checked]="isAuraFilter" /><label for="switch_aura" (click)="toggleAura()">sale_toggle</label>
              </div>
            </div>
          </div>
        </div>
        <div class="filter-section">
          <span class="filter-title">{{t('shared.price')}}</span>
          <div class="filter-item-container">
            <div class="filter-item">
              <!--<ngx-slider [(value)]="minValuePrice" [(highValue)]="maxValuePrice" [options]="optionsPrice" (userChangeEnd)="resizeByPrice($event)"></ngx-slider>-->
              <input type="number" [(ngModel)]="minValuePrice" placeholder="Min" (ngModelChange)="resizeByPrice()">
              <input type="number" [(ngModel)]="maxValuePrice" placeholder="Max" (ngModelChange)="resizeByPrice()">
            </div>
          </div>
        </div>
        <div class="filter-section">
          <span class="filter-title">{{t('shared.lifeStage')}}</span>
          <div class="filter-item-container">
            <div class="filter-item">
              <div class="filter-select-box" *ngFor="let lf of lifeStageArray, let i = index" (click)="selectLifeStage(i)">
                <input type="checkbox" [checked]="lf.selected" /> {{lf.type}}
              </div>
            </div>
          </div>
        </div>
        <div class="filter-section">
          <span class="filter-title">{{t('shared.speciality')}}</span>
          <div class="filter-item-container">
            <div class="filter-item">
              <div class="filter-select-box" *ngFor="let sp of specialityArray, let i = index" (click)="selectSpeciality(i)">
                <input type="checkbox" [checked]="sp.selected" /> {{sp.type}}
              </div>
            </div>
          </div>
        </div>
        <div class="filter-section">
          <span class="filter-title">{{t('shared.elementalPowers')}}</span>
          <div class="filter-item-container">
            <div class="filter-item">
              <span class="second-title">{{t('shared.mainFamily')}}</span>
              <div class="element-box">
                <div class="element-item" *ngFor="let el of elementsArrayMain, let i = index" (click)="selectElementMain(el.type, i);" [ngClass]="{'selected':el.selected}">
                  <img src="{{el.img}}">
                  <p>{{el.type}}</p>
                </div>
              </div>
              <div class="element-slider-box">
                <div class="mb-3">
                  <span class="second-title">{{t('shared.totalPower')}}</span>
                </div>
                <p-slider [(ngModel)]="rangeValue" [range]="true" [min]="0" [max]="10000" (onSlideEnd)="resizeByMain($event)"></p-slider>
                <div class="flex mt-3">
                  <input type="number" pInputText [(ngModel)]="rangeValue[0]" placeholder="Min" (change)="reziseByMainNumber($event)" (ngModelChange)="rangeValue=[rangeValue[0],rangeValue[1]]">
                  <input type="number" pInputText [(ngModel)]="rangeValue[1]" placeholder="Max" (change)="reziseByMainNumber($event)" (ngModelChange)="rangeValue=[rangeValue[0],rangeValue[1]]">
                </div>
                <!-- <ngx-slider [(value)]="minValueMain" [(highValue)]="maxValueMain" [options]="optionsTalent" (userChangeEnd)="resizeByMain($event)"></ngx-slider> -->
              </div>
            </div>
            <div class="filter-item">
              <span class="second-title">{{t('shared.secondFamily')}}</span>
              <div class="element-box">
                <div class="element-item" *ngFor="let el of elementsArraySecond, let i = index" (click)="selectElementSecond(el.type, i);" [ngClass]="{'selected':el.selected}">
                  <img src="{{el.img}}">
                  <p>{{el.type}}</p>
                </div>
              </div>
              <div class="element-slider-box">
                <div class="mb-3">
                  <span class="second-title">{{t('shared.totalPower')}}</span>
                </div>
                <p-slider [(ngModel)]="rangeSecondValue" [range]="true" [min]="0" [max]="10000" (onSlideEnd)="resizeBySecond($event)"></p-slider>
                <div class="flex mt-3">
                  <input type="number" pInputText [(ngModel)]="rangeSecondValue[0]" placeholder="Min" (change)="reziseBySecondNumber($event)" (ngModelChange)="rangeSecondValue=[rangeSecondValue[0],rangeSecondValue[1]]">
                  <input type="number" pInputText [(ngModel)]="rangeSecondValue[1]" placeholder="Max" (change)="reziseBySecondNumber($event)" (ngModelChange)="rangeSecondValue=[rangeSecondValue[0],rangeSecondValue[1]]">
                </div>
                <!-- <ngx-slider [(value)]="minValueSecond" [(highValue)]="maxValueSecond" [options]="optionsTalent" (userChangeEnd)="resizeBySecond($event)"></ngx-slider> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
